import { useQBankStructure } from '@exam-management/qbs-provider';
import { ItemSetQuestionCreationForm } from '@exam-management/qcontent-creation';
import {
  BaseItemSetSubQuestionSection,
  DetailSectionWrapper,
  EmptyItemSetQuestionOverlay,
  FormItemSetQuestionsInLocationSection,
  ItemSetCreationInformationSection,
  ItemSetCreationParagraphSection,
  LocationFormFields,
  LocationSectionWrapper,
  QuestionLayout,
} from '@exam-management/qcontent-management';
import {
  Box,
  Button,
  Flex,
  FormButton,
  PaperSection,
  VisibilityOutlinedIcon,
} from '@shared/components';
import { useMemo } from 'react';

export default function QContentItemSetCreatePage() {
  const { qBankStructureLevels, qBankStructureLevelItems } = useQBankStructure();

  const qBankStructureLevelWithoutFirstLevel = useMemo(
    () => qBankStructureLevels.filter((qBankStructureLevel) => qBankStructureLevel.level !== 1),
    [qBankStructureLevels],
  );

  return (
    <ItemSetQuestionCreationForm qbsLevels={qBankStructureLevelWithoutFirstLevel}>
      <QuestionLayout
        sideContent={
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
            <PaperSection title='Location'>
              <LocationSectionWrapper>
                <LocationFormFields
                  prefix='location'
                  qbsLevels={qBankStructureLevelWithoutFirstLevel}
                  qbsLevelItems={qBankStructureLevelItems}
                />
              </LocationSectionWrapper>
            </PaperSection>
            <FormItemSetQuestionsInLocationSection />
          </Flex>
        }
      >
        <Flex sx={{ width: '100%', flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
          <PaperSection
            title='Question Details'
            endAdornment={
              <Button
                color='secondary'
                variant='outlined'
                startIcon={<VisibilityOutlinedIcon />}
                disabled
              >
                Preview Question
              </Button>
            }
          >
            <DetailSectionWrapper>
              <ItemSetCreationInformationSection />
              <ItemSetCreationParagraphSection />
              <BaseItemSetSubQuestionSection>
                <EmptyItemSetQuestionOverlay />
              </BaseItemSetSubQuestionSection>
            </DetailSectionWrapper>
          </PaperSection>
          <Box>
            <FormButton label='Create Item Set' />
          </Box>
        </Flex>
      </QuestionLayout>
    </ItemSetQuestionCreationForm>
  );
}
